"use client";

import React, { useState, useRef, useEffect } from "react";

// Styles
import * as S from "./styles";
import { Input, Switch } from "../form";
import { BoxSwitchOpenProps } from "@/types";

const BoxSwiperOpen: React.FC<BoxSwitchOpenProps> = ({
  className,
  title,
  description,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (isOpen) {
      el.style.height = el.scrollHeight + "px";
    } else {
      el.style.height = "0px";
    }
  }, [isOpen]);

  return (
    <S.Box className={className}>
      <S.Title>{title}</S.Title>
      <S.BoxDescriptionSwitch>
        <S.Description>
          <S.Paragraph>{description}</S.Paragraph>
        </S.Description>
        <Switch checked={isOpen} onCheckedChange={setIsOpen} />
      </S.BoxDescriptionSwitch>

      <S.BoxOpen ref={contentRef}>{children}</S.BoxOpen>
    </S.Box>
  );
};

export default BoxSwiperOpen;
